import { toast } from 'react-toastify'
import instance from '../../utils/Axios'

import { GET_CLIENTS, GET_CLIENTS_LOADING, SAVE_CLIENT } from './Types'

export const saveClient = (clientData) => (dispatch) => {
  dispatch({
    type: GET_CLIENTS_LOADING,
    payload: true,
  })
  instance
    .post('/clients', {
      ...clientData,
    })
    .then((res) => {
      if (res.data.result !== 'error') {
        dispatch({
          type: SAVE_CLIENT,
          payload: res.data.message,
        })
        return
      }
      toast.error(res.data.message)
    })
    .catch((err) => {
      toast.error(err?.response?.data?.message || 'Error saving client')
    })
    .finally(() => {
      dispatch({
        type: GET_CLIENTS_LOADING,
        payload: false,
      })
    })
}

export const disableClient = (id, disabled) => (dispatch) => {
  instance
    .post(`/clients/${id}/disable`, { disabled })
    .then(() => {
      toast.success(`Client ${disabled ? 'disabled' : 'enabled'} successfully`)
      setTimeout(() => window.location.reload(), 500)
    })
    .catch(() => {
      toast.error('Error disabling client')
    })
}

export const getClients = () => (dispatch) => {
  dispatch({
    type: GET_CLIENTS_LOADING,
    payload: true,
  })
  instance
    .get('/clients')
    .then((res) => {
      dispatch({
        type: GET_CLIENTS,
        payload: res.data.message,
      })
    })
    .catch(() => {
      toast.error('Error fetching clients')
    })
    .finally(() => {
      dispatch({
        type: GET_CLIENTS_LOADING,
        payload: false,
      })
    })
}
